import { createFileRoute } from '@tanstack/react-router'
import MeterPage from '@/views/meter-page'

export const Route = createFileRoute(
  '/_authenticated/_staff/_with_location_switcher/meters/$meterId',
)({
  component: RouteComponent,
  params: {
    parse: (rawParams) => ({ meterId: parseInt(rawParams.meterId)})
  }
})

function RouteComponent() {
  const { meterId } = Route.useParams();
  return <MeterPage meterId={meterId}/>
}
